import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Inicio.css';
//import NewsletterForm from '../../components/NewsletterForm/NewsletterForm';

/* ── Carousel ── */
import carousel1 from '../../assets/carousel/carousel-1.png';
import carousel2 from '../../assets/carousel/carousel-2.png';
import carousel3 from '../../assets/carousel/carousel-3.png';

/* ── Servicios ── */
import imgServicio1 from '../../assets/servicios/servicios-1.png';
import imgServicio2 from '../../assets/servicios/servicios-2.png';
import imgServicio3 from '../../assets/servicios/servicios-3.png';
import imgServicio4 from '../../assets/servicios/servicios-4.png';
import imgServicio5 from '../../assets/servicios/servicios-5.png';
import imgServicio6 from '../../assets/servicios/servicios-6.png';

/* ── Staff ── */
import imgMarco     from '../../assets/staff/staff-marco.png';
import imgCristobal from '../../assets/staff/staff-cristobal.jpg';
import imgJose      from '../../assets/staff/staff-jose.jpg';
import imgJuan      from '../../assets/staff/staff-juan.jpg';
import imgDaniela   from '../../assets/staff/staff-daniela.jpg';
import imgMaria     from '../../assets/staff/staff-maria.jpg';
import imgJaviera   from '../../assets/staff/staff-javiera.jpg';
import imgFrancisco from '../../assets/staff/staff-francisco.jpg';

/* ── Home assets ── */
//import newsletterBg from '../../assets/home/newsletter.png';
import marcasBg     from '../../assets/home/marcas-bg.png';

/* ── Marcas ── */
import logoOHiggins    from '../../assets/marcas/ohiggins.png';
import logoFederacion  from '../../assets/marcas/federacion-futbol.png';
import logoParaclinics from '../../assets/marcas/paraclinics.png';
import logoAccionFutbol from '../../assets/marcas/accion-futbol.png';
import logoEntretenis  from '../../assets/marcas/entretenis.png';
import logoSportValle  from '../../assets/marcas/sport-valle-fc.png';

/* ── Instagram ── */
import instagram1 from '../../assets/instagram/instagram-1.jpg';
import instagram2 from '../../assets/instagram/instagram-2.jpg';
import instagram3 from '../../assets/instagram/instagram-3.jpg';
import instagram4 from '../../assets/instagram/instagram-4.jpg';
import instagram5 from '../../assets/instagram/instagram-5.jpg';
import instagram6 from '../../assets/instagram/instagram-6.jpg';

/* ─────────────────────────────────────── */

const Inicio = () => {
  const [currentSlide,    setCurrentSlide]    = useState(0);
  const [countersStarted, setCountersStarted] = useState(false);
  const [currentServicio, setCurrentServicio] = useState(0);
  const [currentStaff,    setCurrentStaff]    = useState(0);
  const datosRef = useRef(null);

  const slides = [
    { image: carousel1, alt: 'El cambio comienza en tu mente' },
    { image: carousel2, alt: 'Programa de acompañamiento deportivo' },
    { image: carousel3, alt: 'El acompañamiento que transforma tu forma de competir' },
  ];

  const datosData = [
    { number: 12,  prefix: '+', label: 'Años a nivel nacional e internacional' },
    { number: 100, prefix: '+', label: 'Deportistas fortaleciendo su mente' },
    { number: 200, prefix: '+', label: 'Jugadores becados en EEUU' },
  ];

  const servicios = [
    { title: 'Evaluación Psicológica',    image: imgServicio1 },
    { title: 'Acompañamiento Deportivo',  image: imgServicio2 },
    { title: 'Charlas',                   image: imgServicio3 },
    { title: 'Talleres',                  image: imgServicio4 },
    { title: 'Coaching Deportivo',        image: imgServicio5 },
    { title: 'Coaching Empresas',         image: imgServicio6 },
  ];

  const staff = [
    { name: 'Marco Garrido',         image: imgMarco },
    { name: 'Cristóbal Mansilla',    image: imgCristobal },
    { name: 'José Ábalos',           image: imgJose },
    { name: 'Juan Langlois',         image: imgJuan },
    { name: 'Daniela López',         image: imgDaniela },
    { name: 'María de los Ángeles',  image: imgMaria },
    { name: 'Javiera Guerrero',      image: imgJaviera },
    { name: 'Francisco Heresi',      image: imgFrancisco },
  ];

  const marcas = [
    { name: "O'Higgins",                    logo: logoOHiggins },
    { name: 'Federación de Fútbol de Chile', logo: logoFederacion },
    { name: 'Paraclinics',                  logo: logoParaclinics },
    { name: 'Acción Fútbol',               logo: logoAccionFutbol },
    { name: 'Entretenis',                   logo: logoEntretenis },
    { name: 'Sport Valle FC',               logo: logoSportValle },
  ];

  const instagramPosts = [
    { image: instagram1, url: 'https://www.instagram.com/p/DGvi12npWnZ/', alt: 'Psicólogos de la Roja' },
    { image: instagram2, url: 'https://www.instagram.com/p/DUWXnO1iVl0/', alt: "Charla O'Higgins" },
    { image: instagram3, url: 'https://www.instagram.com/p/DRkJZ-akXT7/', alt: 'Marco Garrido' },
    { image: instagram4, url: 'https://www.instagram.com/p/DQP9CiAkh5v/', alt: 'Flow en el deporte' },
    { image: instagram5, url: 'https://www.instagram.com/p/DIt3c-_JWz0/', alt: 'Psicología deportiva' },
    { image: instagram6, url: 'https://www.instagram.com/p/DHMKW8Np6hR/', alt: 'Equipo MG' },
  ];

  const [counters, setCounters] = useState(datosData.map(() => 0));

  /* ── Carousel principal ── */
  useEffect(() => {
    const t = setInterval(() => setCurrentSlide(p => (p + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, [slides.length]);

  /* ── Carousel servicios (de 2 en 2) ── */
  useEffect(() => {
    const t = setInterval(() => setCurrentServicio(p => (p + 2) % servicios.length), 4000);
    return () => clearInterval(t);
  }, [servicios.length]);

  /* ── Carousel staff (de 3 en 3) ── */
  useEffect(() => {
    const t = setInterval(() => setCurrentStaff(p => (p + 3) % staff.length), 4000);
    return () => clearInterval(t);
  }, [staff.length]);

  /* ── Contadores animados ── */
  useEffect(() => {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !countersStarted) {
          setCountersStarted(true);
          animateCounters();
        }
      });
    },
    { threshold: 0.3 }
  );
  const currentRef = datosRef.current;
  if (currentRef) observer.observe(currentRef);
  return () => { if (currentRef) observer.unobserve(currentRef); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [countersStarted]);

  const animateCounters = () => {
    datosData.forEach((dato, index) => {
      let start = 0;
      const end = dato.number;
      const increment = end / (2000 / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCounters(prev => { const n = [...prev]; n[index] = end; return n; });
          clearInterval(timer);
        } else {
          setCounters(prev => { const n = [...prev]; n[index] = Math.floor(start); return n; });
        }
      }, 16);
    });
  };

  const goToSlide    = i => setCurrentSlide(i);
  const nextSlide    = () => setCurrentSlide(p => (p + 1) % slides.length);
  const prevSlide    = () => setCurrentSlide(p => (p - 1 + slides.length) % slides.length);
  const nextServicio = () => setCurrentServicio(p => (p + 2) % servicios.length);
  const prevServicio = () => setCurrentServicio(p => (p - 2 + servicios.length) % servicios.length);
  const nextStaff    = () => setCurrentStaff(p => (p + 3) % staff.length);
  const prevStaff    = () => setCurrentStaff(p => (p - 3 + staff.length) % staff.length);

  return (
    <div className="inicio-container">

      {/* ══ CAROUSEL PRINCIPAL ══ */}
      <section className="carousel-section">
        <div className="carousel-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="carousel-overlay" />
            </div>
          ))}
          <button className="carousel-button prev" onClick={prevSlide}>‹</button>
          <button className="carousel-button next" onClick={nextSlide}>›</button>
          <div className="carousel-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ══ DATOS DUROS ══ */}
      <section className="datos-section" ref={datosRef}>
        <div className="section-container">
          <div className="datos-grid">
            {datosData.map((dato, index) => (
              <div key={index} className="dato-card">
                <div className="dato-number">{dato.prefix}{counters[index]}</div>
                <div className="dato-label">{dato.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ VIDEOS ══ */}
      <section className="video-section">
        <div className="section-container">
          <div className="videos-grid">
            {[
              { id: 'HAwsSaQKlJc', title: 'MG Profesionales Video 1' },
              { id: 'dx3eJv-zrdo', title: 'MG Profesionales Video 2' },
              { id: 'oKSUx6wx4Rs', title: 'MG Profesionales Video 3' },
            ].map((v, i) => (
              <div key={i} className="video-item">
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={v.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="youtube-video-player"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ SERVICIOS PREVIEW ══ */}
      <section className="servicios-preview-section">
        <div className="section-container">
          <h2 className="section-title">Nuestros Servicios</h2>
          <div className="servicios-carousel">
            <button className="carousel-nav-button prev" onClick={prevServicio}>‹</button>
            <div className="servicios-carousel-container">
              {servicios.map((servicio, index) => (
                <div
                  key={index}
                  className={`servicio-carousel-item ${
                    index === currentServicio || index === currentServicio + 1 ? 'active' : ''
                  }`}
                >
                  <div className="servicio-carousel-image">
                    <img src={servicio.image} alt={servicio.title} />
                  </div>
                  <h3 className="servicio-carousel-title">{servicio.title}</h3>
                </div>
              ))}
            </div>
            <button className="carousel-nav-button next" onClick={nextServicio}>›</button>
          </div>
          <div className="carousel-dots">
            {Array.from({ length: Math.ceil(servicios.length / 2) }).map((_, index) => (
              <span
                key={index}
                className={`dot ${index * 2 === currentServicio ? 'active' : ''}`}
                onClick={() => setCurrentServicio(index * 2)}
              />
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/servicios" className="inicio-ver-mas-btn">Ver todos los servicios →</Link>
          </div>
        </div>
      </section>

 

      {/* ══ STAFF PREVIEW ══ */}
      <section className="staff-preview-section">
        <div className="section-container">
          <h2 className="section-title">Nuestro Staff</h2>
          <div className="staff-carousel">
            <button className="carousel-nav-button prev" onClick={prevStaff}>‹</button>
            <div className="staff-carousel-container">
              {staff.map((member, index) => (
                <div
                  key={index}
                  className={`staff-carousel-item ${
                    index === currentStaff ||
                    index === currentStaff + 1 ||
                    index === currentStaff + 2 ? 'active' : ''
                  }`}
                >
                  <div className="staff-carousel-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h3 className="staff-carousel-name">{member.name}</h3>
                </div>
              ))}
            </div>
            <button className="carousel-nav-button next" onClick={nextStaff}>›</button>
          </div>
          <div className="carousel-dots">
            {Array.from({ length: Math.ceil(staff.length / 3) }).map((_, index) => (
              <span
                key={index}
                className={`dot ${index * 3 === currentStaff ? 'active' : ''}`}
                onClick={() => setCurrentStaff(index * 3)}
              />
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/quienes-somos/staff" className="inicio-ver-mas-btn">Conoce al equipo →</Link>
          </div>
        </div>
      </section>

      {/* ══ INSTAGRAM ══ */}
      <section className="instagram-section">
        <div className="section-container">
          <h2 className="section-title">Síguenos en Instagram</h2>
          <div className="instagram-grid">
            {instagramPosts.map((post, index) => (
              <a
                key={index}
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-post"
              >
                <img src={post.image} alt={post.alt} />
                <div className="instagram-overlay">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="instagram-icon">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ══ MARCAS ══ */}
      <section className="marcas-section" style={{ backgroundImage: `url(${marcasBg})` }}>
        <div className="section-container">
          <h2 className="section-title">Proyectos que Confían en Nosotros</h2>
          <div className="marcas-carousel-wrapper">
            <div className="marcas-carousel">
              {[...marcas, ...marcas].map((marca, index) => (
                <div key={index} className="marca-item">
                  <img src={marca.logo} alt={marca.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Inicio;
